import { Component, OnInit } from '@angular/core';
import { ModalStudentProfileAvatarComponent } from '../student/student-profile/modal-student-profile-avatar/modal-student-profile-avatar.component';
import { AuthenticationService } from '../shared/services/authentication.service';
import { ModalService } from '../shared/services/modal.service';
import { catchError } from 'rxjs/operators';
import { empty } from '../functions';
import { studentprofilePlaceholder } from '../model/model.studentprofile';
import { UserService } from '../shared/services/user.service';
import { ModelUser } from '../model/model.user';
import { ModalAccountAvatarComponent } from '../account/modal-account-avatar/modal-account-avatar.component';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { passwordResetUrl } from '../auth.config';
import { alertMessages, AlertService } from '../shared/services/alert.service';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { LocaleService } from '../shared/services/locale.service';

@Component({
  selector: 'app-company-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false,
})
export class AccountComponent implements OnInit {
  faEdit = faEdit;

  public successMessage = '';

  avatarPlaceholder = studentprofilePlaceholder.avatarPlaceholder;

  public passwordResetUrl = passwordResetUrl;

  entity: ModelUser = {
    id: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    avatarUri: '',
    allowEmailNotifications: false,
    isSubscribedToNewsletter: false,
    roles: [],
    preferredLanguage: '',
    hasAcceptedGdprPolicy: false,
    disableTargetGroupsCompanies: true,
    disableTargetGroupsJobs: true,
    disableTargetGroupsMeetDays: true,
  };

  get isCompanyUser(): boolean {
    return this.entity.roles?.includes('Bedrijf') ?? false;
  }

  /**
   * Constructor
   *
   * @param authService
   * @param userService
   * @param modal
   */
  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private authService: AuthenticationService,
    private alertService: AlertService,
    private userService: UserService,
    public modal: ModalService,
    public locale: LocaleService
  ) {}

  /**
   * Ng on init
   */
  ngOnInit(): void {
    this.loadAccount(() => {
      // Check if we need to check upon account credentials that are changed
      if (this.router.url.indexOf('/account/resetpassword') !== -1) {
        this.successMessage = 'Your password has been successfully changed';
      }
    });
  }

  /**
   * Update user account current
   * @param $account
   */
  updateAccountEmailAddress($accountId: string, $account: ModelUser) {
    this.userService
      .apiUpdateAccountCurrent($accountId, $account)
      .subscribe((response) => {
        // Reload current account data
        this.userService
          .apiGetAccountCurrent()
          .pipe(
            catchError(
              this.userService.handleError('apiGetAccountCurrent', false)
            )
          )
          .subscribe((account) => {
            if (account) {
              this.authService.setProfileData(account);
            }
          });
      });
  }

  /**
   * Load account
   */
  loadAccount(cb: any = null) {
    this.authService.profile$.subscribe((account) => {
      if (account !== null && !empty(account)) {
        this.entity = Object.assign({}, <ModelUser>account);

        if (typeof cb == 'function') {
          cb.call();
        }
      } else {
      }
    });
  }

  /**
   * Refresh account with latest server data
   */
  refreshCurrentAccount() {
    // Reload current account data
    this.userService
      .apiGetAccountCurrent()
      .pipe(
        catchError(this.userService.handleError('apiGetAccountCurrent', false))
      )
      .subscribe((account) => {
        if (account) {
          this.authService.setProfileData(account);
        }
      });
  }

  /**
   * Edit the student its avatar / profile image
   */
  editAvatar() {
    this.authService.profile$
      .subscribe((account) => {
        if (account !== null) {
          const modalOptions = {
            backdrop: 'static',
            size: 'xl',
          };

          const data = Object.assign({}, account);

          this.modal
            .Modal(
              ModalAccountAvatarComponent,
              'Profile image',
              '',
              data,
              [],
              modalOptions
            )
            .then((result) => {
              if (result === true) {
                this.refreshCurrentAccount();
              }
            })
            .catch((error) => {});
        }
      })
      .unsubscribe();
  }

  /**
   * Save account
   *
   * @constructor
   */
  Save() {
    if (empty(this.entity.id)) return;

    this.userService
      .apiUpdateAccountCurrent(this.entity.id, this.entity)
      .pipe(
        catchError(
          this.userService.handleError('apiUpdateAccountCurrent', false)
        )
      )
      .subscribe((result) => {
        if (result !== false) {
          this.alertService.success(alertMessages.successDataSaved);

          if (
            !empty(this.entity.preferredLanguage) &&
            typeof this.entity.preferredLanguage == 'string'
          ) {
            this.locale.setLanguage(this.entity.preferredLanguage);
          }

          // Renew current account data
          this.userService
            .apiGetAccountCurrent()
            .pipe(
              catchError(
                this.userService.handleError('apiGetAccountCurrent', false)
              )
            )
            .subscribe((account) => {
              if (account) {
                this.authService.setProfileData(account);
              }
            });
        }
      });
  }
}
